<template>
  <div>
    <h1>{{ pageHeader }}</h1>

    <form class="lihavapp-form">
      <div class="form-group">
        <label for="measurement">Blood sugar measurement in mmol/L</label>
        <input
          type="number"
          class="form-control"
          id="measurement"
          name="measurement"
          v-model.number="measurement"
          required
          :disabled="showModeActive"
        />
      </div>

      <section>
        <div class="form-group">
          <label for="date">Measurement date</label>
          <input
            type="date"
            v-model="date"
            class="form-control"
            placeholder="Select date"
            :disabled="showModeActive"
          />
        </div>

        <div class="form-group">
          <label>Measurement time (optional)</label>
          <div class="input-group mb-3">
            <input
              type="time"
              class="form-control"
              id="time"
              name="time"
              placeholder
              v-model="time"
              required
              :disabled="showModeActive"
              step="60"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                type="button"
                v-on:click="clearTime()"
                :disabled="showModeActive"
              >Clear</button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Comment (optional)</label>
          <input
            class="form-control"
            type="text"
            name="comment"
            v-model="comment"
            :disabled="showModeActive"
          />
        </div>
      </section>

      <div class="form-group lihavapp-form-control-button-holder">
        <button
          type="button"
          class="btn btn-primary mr-3"
          v-on:click="create()"
          v-if="createModeActive"
        >Create</button>

        <button
          type="button"
          class="btn btn-secondary mr-3"
          v-on:click="update()"
          v-if="editModeActive"
        >Update</button>

        <button
          type="button"
          class="btn btn-outline-secondary"
          v-on:click="cancel()"
          v-if="createModeActive || editModeActive"
        >Cancel</button>

        <button
          type="button"
          class="btn btn-outline-danger float-right"
          v-on:click="deleteMeasurement"
          v-if="editModeActive"
        >Delete</button>

        <button
          type="button"
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'blood-sugar' });"
          v-if="showModeActive"
        >Back</button>

        <button
          type="button"
          class="btn btn-outline-secondary float-right"
          v-on:click="edit()"
          v-if="showModeActive"
        >Edit measurement</button>
      </div>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "BloodSugarShowCreateEdit",
  components: {},
  data: function() {
    return {
      store: store,
      measurement: null,
      comment: "",
      bloodSugarMeasurement: {
        measurement: "",
        time: "",
        date: ""
      },
      date: this.moment().format("YYYY-MM-DD"),
      time: this.moment().format("HH:mm")
    };
  },
  created: function() {},
  mounted: function() {
    if (this.showModeActive || this.editModeActive) {
      let object = this.store.getBloodSugarMeasurement(this.$route.params.id);

      if (object == undefined) {
        return;
      }

      this.measurement = (object.measurement / 10).toFixed(1);

      this.date = this.moment(object.date).format("YYYY-MM-DD");

      if (object.time)
        this.time = this.moment(object.time, "HH:mm:ss").format("HH:mm");
      else this.time = null;

      this.comment = object.comment;
    }
  },
  computed: {
    showModeActive: function() {
      return this.$route.name == "blood-sugar.show";
    },
    createModeActive: function() {
      return this.$route.name == "blood-sugar.create";
    },
    editModeActive: function() {
      return this.$route.name == "blood-sugar.edit";
    },
    pageHeader: function() {
      if (this.showModeActive) {
        return "Show blood sugar measurement";
      }

      if (this.editModeActive) {
        return "Edit blood sugar measurement";
      }

      return "Add new blood sugar measurement";
    }
  },
  methods: {
    updateMeasurementObject: function() {
      this.bloodSugarMeasurement.measurement = Math.round(this.measurement*10);

      this.bloodSugarMeasurement.time = this.time; //this.moment(this.time).format("HH:mm");

      this.bloodSugarMeasurement.date = this.date; //this.moment(this.date).format("D.M.YYYY");
      this.bloodSugarMeasurement.comment = this.comment;
    },
    create: function() {
      this.updateMeasurementObject();

      let self = this;
      this.axios
        .post("/bloodsugar", this.bloodSugarMeasurement)
        .then(function(response) {
          let measurement = response.data;
          self.store.addBloodSugarMeasurement(measurement);
          self.flashSuccess("New blood sugar measurement stored successfully");
          self.$router.push({ name: "blood-sugar" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    edit: function() {
      this.$router.push({
        name: "blood-sugar.edit",
        params: { id: this.$route.params.id }
      });
    },
    update: function() {
      this.updateMeasurementObject();

      let self = this;
      this.axios
        .put("/bloodsugar/" + this.$route.params.id, this.bloodSugarMeasurement)
        .then(function(response) {
          let updated = response.data;

          if (self.store.updateBloodSugarMeasurement(updated)) {
            self.flashSuccess("Blood sugar measurement updated successfully");
            self.$router.push({ name: "blood-sugar" });
          } else {
            self.flashError(
              "Failed to update blood sugar measurement data structure"
            );
          }
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    cancel: function() {
      if (this.editModeActive) {
        this.$router.push({
          name: "blood-sugar.show",
          params: { id: this.$route.params.id }
        });
      } else {
        let returnRoute = "blood-sugar";

        if (this.store.state.bloodSugarView.cancelRoute)
        {
          returnRoute = this.store.state.bloodSugarView.cancelRoute;
        }

        this.$router.push({ name: returnRoute });
      }
    },

    deleteMeasurement: function() {
      if (!this.editModeActive) return;

      let measurement = this.store.getBloodSugarMeasurement(this.$route.params.id);

      if (measurement == undefined) {
        return;
      }
      let confirmationText =
        "Are you sure that you want to delete this blood sugar measurement?";

      if (!confirm(confirmationText)) {
        return;
      }

      var self = this;
      this.axios
        .delete("/bloodsugar/" + measurement.id)
        .then(function(response) {
          // handle success
          let removed = self.store.removeBloodSugarMeasurement(measurement.id);

          if (removed) {
            self.flashSuccess("Blood sugar measurement deleted successfully");
          } else {
            self.flashSuccess(
              "Blood sugar measurement removed from server, but deleting from local data structure failed"
            );
          }

          self.$router.push({ name: "blood-sugar" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    clearTime: function() {
      this.time = "";
    }
  }
};
</script>

<style scoped>
</style>